import React from 'react';
import { Fade } from "react-awesome-reveal";
import { FeaturesContent } from '../../api/homepage';
import check from '../../images/icon/check.svg'
import error from '../../images/icon/erorr.svg'
import logo from '../../images/logo/logo-white.svg'
import star from '../../images/icon/star.svg'

const FeaturesSection = (props) => {
    return (
        <section className="feature">
            <div className="feature-wrapper sec-bg sec-bg--2 pt-130 pb-130">
                <div className="container">
                    <div className="feature_inner">
                        <div className="sec-title--two text-center mb-60">
                            <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                                <div>
                                    <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                        <img src={star} alt="" />{FeaturesContent.subtitle}
                                    </div>
                                </div>
                            </Fade>
                            <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                                <div>
                                    <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">
                                        {FeaturesContent.title}
                                    </h2>
                                </div>
                            </Fade>
                        </div>
                        <table className="feature-table">
                            <thead>
                                <tr>
                                    <th>{FeaturesContent.tableHeaders.column1}</th>
                                    <th><img src={logo} alt="" width="70%"/></th>
                                    <th>{FeaturesContent.tableHeaders.column3}</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {FeaturesContent.features.map((feature, index) => (
                                    <tr key={index}>
                                        <td>{feature.capability}</td>
                                        <td><img src={feature.bogintech ? check : error} alt="" /></td>
                                        <td><img src={feature.traditional ? check : error} alt="" /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;